<script>
import Money from '@src/mixins/money'
import ActionConfirmationModal from './ActionConfirmationModal.vue'

export default {
  mixins: [Money],
  emits: ['confirm', 'hidden'],
  components: {
    ActionConfirmationModal,
  },
  props: {
    sale: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    clientName() {
      return this.sale.client && this.sale.client.name
        ? this.sale.client.name
        : '-'
    },
    saleIdentifier() {
      return this.sale.transaction_id || this.sale.id || '-'
    },
    saleValue() {
      return this.sale.total != null ? this.sale.total : this.sale.amount || 0
    },
    action() {
      return {
        title: 'Reembolsar Venda',
        initialDescription: 'Tem certeza que deseja reembolsar esta venda?',
        confirmationDescription: 'Digite a frase abaixo para confirmar o reembolso',
        confirmationPhrase: 'REEMBOLSAR VENDA',
        nextLabel: 'Avançar e Reembolsar',
        confirmLabel: 'Confirmar Reembolso',
        alert: {
          title: 'Ação Irreversível',
          description:
            'Esta ação não pode ser desfeita. O valor será estornado para o cliente e a venda será marcada como reembolsada.',
        },
      }
    },
    confirmationFields() {
      return [
        { label: 'Cliente', value: this.clientName },
        { label: 'ID da Venda', value: this.saleIdentifier },
        { label: 'Valor', value: `R$ ${this.formatMoney(this.saleValue)}` },
      ]
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('confirm')
    },
  },
}
</script>

<template>
  <ActionConfirmationModal
    id="refund-sale-modal"
    :action="action"
    :confirmation-fields="confirmationFields"
    :loading="loading"
    :error-message="errorMessage"
    @confirm="handleSubmit"
    @hidden="$emit('hidden')"
  />
</template>
